import React from 'react';
import ReactDOM from 'react-dom/client';
import './output.css';
import reportWebVitals from './reportWebVitals';
import {NextUIProvider} from "@nextui-org/react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import NavbarComponent from "./Components/navbar.component";
import HeroComponent from "./Components/Hero.component";
import HomePage from "./Page/HomePage";
import DetailScreen from "./Page/DetailScreen";
import ContactUsPage from "./Page/ContactUsPage";
import FavComponent from "./Components/Fav.component";
import SkinViewer from "./Page/SkinViewer";
import PrivacyPolicy from "./Page/PrivacyPolicy";
import PrivacyPolicyBrawlStar from "./Page/PrivacyPolicyBrawlStar";
import PrivacyPolicyCmReward from "./Page/PrivacyPolicyCmReward";
import PrivacyPolicyMc from "./Page/PrivacyPolicyMc";
import Terms from "./Page/Terms";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <NextUIProvider>

            <Router>
                <NavbarComponent/>
                <Routes>
                    {/*<Route path="/app-ads.txt" element={<AppAdsFile/>}/>*/}
                    <Route path="/" element={<HomePage/>}/>
                    <Route path="/skins" element={<HeroComponent title={"Latest Skins"} baseUrl={
                        "https://dataapi.miracocopepsi.com/public/api/minecraft/skins"
                    }/>}/>
                    <Route path="/skins/boys" element={<HeroComponent title={"Boys Skins"} baseUrl={
                        "https://dataapi.miracocopepsi.com/public/api/minecraft/skins/boys"
                    }/>}/>
                    <Route path="/skins/girls" element={<HeroComponent title={"Girls Skins"} baseUrl={
                        "https://dataapi.miracocopepsi.com/public/api/minecraft/skins/girls"
                    }/>}/>
                    <Route path="/skins/pocketEdition" element={<HeroComponent title={"Pocket Edition Skins"} baseUrl={
                        "https://dataapi.miracocopepsi.com/public/api/minecraft/skins/pocketEdition"
                    }/>}/>
                    <Route path="/skins/mostDownloaded"
                           element={<HeroComponent title={"Most Downloaded Skins"} baseUrl={
                               "https://dataapi.miracocopepsi.com/public/api/minecraft/skins/mostDownload"
                           }/>}/>
                    <Route path="/skins/caves" element={<HeroComponent title={"Caves"} baseUrl={
                        "https://dataapi.miracocopepsi.com/public/api/minecraft/skins/caves"
                    }/>}/>


                    <Route path="/skins/favourite" element={<FavComponent/>}/>
                    <Route path="/skinViewer" element={<SkinViewer/>}/>
                    <Route path="/skins/Details/:skinId" element={<DetailScreen/>}/>
                    <Route path="/contactus" element={<ContactUsPage/>}/>
                    <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
                    <Route path="/terms" element={<Terms/>}/>
                    <Route path="/privacyPolicyMc" element={<PrivacyPolicyMc/>}/>
                    <Route path="/privacy-policy/BrawlStar" element={<PrivacyPolicyBrawlStar/>}/>
                    <Route path="/privacy-policy/CmReward" element={<PrivacyPolicyCmReward/>}/>
                </Routes>
            </Router>
        </NextUIProvider>
    </React.StrictMode>
);

reportWebVitals();
